export default "__VITE_ASSET__8erSmK72__"